import { render, staticRenderFns } from "./create-password.vue?vue&type=template&id=5aaaa832&scoped=true&"
import script from "./create-password.vue?vue&type=script&lang=js&"
export * from "./create-password.vue?vue&type=script&lang=js&"
import style0 from "./create-password.vue?vue&type=style&index=0&id=5aaaa832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaaa832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRow,VTextField})
